import React from 'react'
import { ThemeProvider } from '@/lib/styles'

function ResetPage() {
  return <ThemeProvider></ThemeProvider>
}

export default ResetPage
